import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'
import DateRangePicker from 'react-bootstrap-daterangepicker'

import { useGetMutateCall } from '../../lib/api/get'
import { NoDataCard } from '../../common/NoDataCard'

import 'bootstrap-daterangepicker/daterangepicker.css'

export const ExpenseReport = ({
  routeData,
  authDetails,
  modSchema = JSON.parse(routeData.apiEndPointSchema),
  isLocalEnvironment,
}) => {
  const [reportData, setReportData] = React.useState(null)
  const [reportDataAfterFilter, setReportDataAfterFilter] = React.useState(null)
  const getCallMutation = useGetMutateCall()

  const [selectedDates, setSelectedDates] = React.useState(null)

  const handleCallback = (start, end) => {
    setSelectedDates({
      start: dayjs(start._d).format('YYYY-MM-DD'),
      end: dayjs(end._d).format('YYYY-MM-DD'),
    })
  }

  const onSearch = async (e) => {
    e.preventDefault()

    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'expenseAccounts',
        params:
          '&expFrom=' +
          dayjs(selectedDates.start).format('YYYY-MM-DD 00:00:00') +
          '&expTo=' +
          dayjs(selectedDates.end).format('YYYY-MM-DD 23:59:59') +
          `&${modSchema.moduleAddParam ? modSchema.moduleAddParamString : ''}`,
        isDynamic: true,
      })
      .then((resp) => {
        const dataRes = []
        let totalExpenses = 0
        resp.formData.length > 0 &&
          resp.formData.map((r) => {
            let tot = 0
            r.expenses.map((e) => {
              tot = tot + parseInt(e.expenseAmount)
              r.expenseTotal = tot
            })
            totalExpenses = totalExpenses + r.expenseTotal
            dataRes.push({ ...r, totalExpenses })
          })
        setReportData(dataRes)
      })
  }

  const filterByName = (e) => {
    if (reportDataAfterFilter === null) {
      setReportDataAfterFilter(reportData)
    }
    if (e.target.value === '') {
      if (reportDataAfterFilter !== null) {
        setReportData(reportDataAfterFilter)
        setReportDataAfterFilter(null)
      } else {
        const filterData = reportData.filter((f) => f.expenseAccountName === e.target.value)
        setReportData(filterData)
      }
    } else {
      const filterData = reportData.filter((f) => f.expenseAccountName === e.target.value)
      setReportData(filterData)
    }
  }

  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false

  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between">
            <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
          </div>
        </div>
      </div>
      <div className="trtui-card-body">
        <form
          onSubmit={(e) => onSearch(e)}
          id="searchForm"
          className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between"
        >
          <div className="trtui-row">
            <div key="fromDate" className="trtui-col-md-10">
              <label>Date Range</label>
              <DateRangePicker onCallback={handleCallback}>
                <input className="trtui-form-control" />
              </DateRangePicker>
            </div>
            <div className="trtui-col-md-2" style={{ paddingTop: '1.7rem' }}>
              <button
                className="trtui-btn trtui-btn-icon trtui-btn-primary"
                disabled={getCallMutation.isLoading}
              >
                {getCallMutation.isLoading ? (
                  <span className="trtui-d-flex trtui-align-items-center">
                    <span className="trtui-flex-grow-1 trtui-me-2"> </span>
                    <span className="trtui-spinner-border trtui-flex-shrink-0" role="status">
                      <span className="trtui-visually-hidden"> </span>
                    </span>
                  </span>
                ) : (
                  <i className="ri-search-line" />
                )}
              </button>
            </div>
          </div>
          {authDetails.role !== 'Staff' && (
            <div>
              <label>Filter By</label>
              <select className="trtui-form-control" onChange={(e) => filterByName(e)}>
                <option value="">Show All</option>
                {reportData !== null &&
                  reportData.length > 0 &&
                  reportData.map((f, fInd) => (
                    <option key={fInd} value={f.expenseAccountName}>
                      {f.expenseAccountName}
                    </option>
                  ))}
              </select>
            </div>
          )}
        </form>
      </div>
      {getCallMutation.isLoading ? (
        <div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '20%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div key={reportData} className="trtui-row trtui-justify-content-center">
          <div className="trtui-col-12">
            <div className="trtui-card trtui-p-1" style={{ overflowX: 'scroll' }}>
              {reportData !== null && 'Total Expenses:'}{' '}
              {reportData?.length > 0 && reportData[reportData.length - 1].totalExpenses.toFixed(2)}
              {reportData !== null && reportData.length > 0 ? (
                reportData.map((rep, repInd) => (
                  <React.Fragment key={repInd}>
                    <div className="trtui-table-responsive trtui-mt-4 trtui-mt-xl-0">
                      <table className="trtui-table trtui-table-hover trtui-table-striped trtui-align-middle trtui-table-nowrap trtui-mb-0">
                        <thead>
                          <tr>
                            <td
                              colSpan={authDetails.role === 'Staff Admin' ? 4 : 5}
                              className="trtui-text-center trtui-pt-3 trtui-pb-3 trtui-fw-semibold"
                            >
                              {rep.expenseAccountName}
                              {' - '}
                              {rep.expenseAccountType}
                              <span style={{ fontSize: '0.7rem' }} title="Total Amount">
                                ({rep.expenseTotal.toFixed(2)})
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Mode</th>
                            <th scope="col">Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rep.expenses.length > 0 &&
                            rep.expenses
                              .sort(
                                (a, b) =>
                                  new Date(...a.checkInDateTime.split('/').reverse()) -
                                  new Date(...b.checkInDateTime.split('/').reverse()),
                              )
                              .map((d, dInd) => (
                                <tr key={dInd}>
                                  <td className="trtui-fw-medium">
                                    {dayjs(d.checkInDateTime).format('YYYY-MM-DD')}
                                  </td>
                                  <td>{d.expenseAmount}</td>
                                  <td>{d.expensePaymentType}</td>
                                  <td>{d.expenseRemarks}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  </React.Fragment>
                ))
              ) : (
                <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} />
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

ExpenseReport.propTypes = {
  routeData: PropTypes.object,
  authDetails: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
  modSchema: PropTypes.object,
}
